import React, { useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { subDays, format } from 'date-fns';
import * as Yup from 'yup';

import { Report } from '~/components';
import { DateTime, RadioGroup } from '~/components/Form';
import { t } from '~/helpers';
import { validation } from '~/helpers/yupValidations';

export default function RelRegimeEspecialAnglo() {
  const [open, setOpen] = useState(true);

  const { client, id } = useSelector((state) => state.user.profile);

  const dateTime = useMemo(
    () => ({
      start: format(subDays(new Date(), 7), 'dd/MM/yyyy 00:00:00'),
      end: format(new Date(), 'dd/MM/yyyy 23:59:59'),
    }),
    []
  );

  const exports = useMemo(
    () => [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel', value: 'xls' },
    ],
    []
  );

  // Data validation
  const handleDataValidation = useCallback(async (data) => {
    try {
      const schema = Yup.object().shape({
        datahorainicial: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio')),
      });

      await validation(schema, data);
    } catch (error) {
      const form = {};

      if (error instanceof Yup.ValidationError) {
        error.inner.forEach((e) => {
          form[e.path] = e.message.replace(`${e.path} `, '');
        });

        // eslint-disable-next-line no-throw-literal
        throw { form };
      }
    }
  }, []);

  const handleSerializeFormData = useCallback((data) => ({
    ...data,
    idcliente: client,
    idusuario: id,
  }));

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.relregimeespecialanglo')}
      relatorio="relregimeespecialanglo"
      serialize={handleSerializeFormData}
      validate={handleDataValidation}
      initials={{
        datahorainicial: dateTime.start,
        datahorafinal: dateTime.end,
        tipo: 'pdf',
      }}
    >
      <DateTime
        time
        name="datahorainicial"
        label={t('s.geral.opcoes.datahorainicial')}
      />

      <DateTime
        time
        name="datahorafinal"
        label={t('s.geral.opcoes.datahorafinal')}
      />

      <RadioGroup
        row
        name="tipo"
        label={t('s.relatorio.geral.formato')}
        options={exports}
        serialize={(value) => value}
      />
    </Report>
  );
}
